import { PopoverPlacementType } from "../popover/interface";

export interface GuidedTourData {
    autoStart?: boolean;
    autoStartLabel?: string;
    intro?: GuidedTourStep;
    outro?: GuidedTourStep;
    steps: GuidedTourStep[];
}

export interface GuidedTourStep {
    backButtonClassNames?: string;
    backButtonLabel?: string;
    body: string;
    focusFx?: "glow" | "shadow";
    nextButtonClassNames?: string;
    nextButtonLabel?: string;
    placement?: PopoverPlacementType;
    target?: string;
    targetOffset?: number;
    title?: string;
    hideStepsCount?: boolean;
    hideProgressBar?: boolean;
}
